import Link from "admin/shared/ui/Link.Component";

const TableCellAccountRedirect = ({ type, value }) => {
  return (
    <Link toState={"userOverview"} parameters={[type, value]} target="_blank">
      {value}
    </Link>
  );
};

export default TableCellAccountRedirect;
